var _defs, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g, _path48, _ellipse, _path49, _path50, _path51, _ellipse2, _path52, _path53, _path54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBankharHead = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235.01,
    height: 300,
    viewBox: "0 0 235.01 300",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 4.66,
    width: 235.01,
    height: 295.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.48,108.23c.07-1.6.12-3.2.12-4.8,0-57.24-47.72-98.76-102.19-98.76s-102,40.42-102,97.66c0,2,.07,4,.19,6H13.4l.34,2A108.09,108.09,0,0,0,17,129.47l15.1,89.66c3,17.77,13.84,31.18,28.31,43.22A106.65,106.65,0,0,0,84.55,277.9,117.84,117.84,0,0,0,98.12,283h0a37.88,37.88,0,0,0,3.77,1c1.26.29,2.48.52,3.63.67a68.68,68.68,0,0,0,20.08.1,42,42,0,0,0,7-1.39,65.42,65.42,0,0,0,9.13-3.05h0c2.53-1,4.6-1.86,5.75-2.38a106.71,106.71,0,0,0,24.18-15.54c14.47-12,25.31-25.46,28.31-43.22,6.22-36.94,11.27-74,17.5-110.91h0",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: 30.24,
    y: 0,
    width: 168.34,
    height: 64.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.24 0 198.58 0 198.58 64.39 30.24 64.39 30.24 0",
    fill: "#fff"
  }))))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "bankhar_head_2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.67,147.22",
    transform: "translate(0 0)",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.48,108.23c.07-1.6.12-3.2.12-4.8,0-57.24-47.72-98.76-102.19-98.76s-102,40.42-102,97.66c0,2,.07,4,.19,6H13.4l.34,2A108.09,108.09,0,0,0,17,129.47l15.1,89.66c3,17.77,13.84,31.18,28.31,43.22A106.65,106.65,0,0,0,84.55,277.9,117.84,117.84,0,0,0,98.12,283h0a37.88,37.88,0,0,0,3.77,1c1.26.29,2.48.52,3.63.67a68.68,68.68,0,0,0,20.08.1,42,42,0,0,0,7-1.39,65.42,65.42,0,0,0,9.13-3.05h0c2.53-1,4.6-1.86,5.75-2.38a106.71,106.71,0,0,0,24.18-15.54c14.47-12,25.31-25.46,28.31-43.22,6.22-36.94,11.27-74,17.5-110.91h0",
    transform: "translate(0 0)",
    fill: "#262322"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.69,235.83v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.23,235.83v31.7c0,21.89-21.17,29.55-21.17,29.55S21.9,289.4,21.9,267.53v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,235.83v32C108,291.67,85.39,300,85.39,300s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.93,235.83v31.7c0,21.89-28.35,29.55-28.35,29.55s-28.35-7.68-28.35-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,235.83v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.64,235.83v31.7c0,21.89-24,29.55-24,29.55s-24-7.68-24-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,235.83v32c0,23.79-22.63,32.12-22.63,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,235.83v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235,235.83v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.55,235.83v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,208.12v32.05c0,23.8-22.62,32.12-22.62,32.12S0,264,0,240.17V208.12Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.79,209.58v31.7c0,21.89-21.17,29.55-21.17,29.55S1.46,263.15,1.46,241.28v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,208.12v32.05C87.58,264,65,272.29,65,272.29S42.33,264,42.33,240.17V208.12Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.12,209.58v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,208.12v32.05c0,23.8-22.62,32.12-22.62,32.12S83.2,264,83.2,240.17V208.12Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127,209.58v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,208.12v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V208.12Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.32,209.58v31.7c0,21.89-21.17,29.55-21.17,29.55S127,263.15,127,241.28v-31.7Z",
    transform: "translate(0 0)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,208.12v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V208.12Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.65,209.58v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,181.87v32.06c0,23.79-22.62,32.11-22.62,32.11s-22.62-8.32-22.62-32.11v-32H65.69Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.23,181.87v31.7c0,21.89-21.17,29.55-21.17,29.55S21.9,235.44,21.9,213.57v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,181.87v32.06C108,237.72,85.39,246,85.39,246s-22.62-8.32-22.62-32.11v-32H108Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56,181.87v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,181.87v32.06c0,23.79-22.62,32.11-22.62,32.11s-22.62-8.32-22.62-32.11v-32h45.25Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.89,181.87v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,181.87v32.06c0,23.79-22.63,32.11-22.63,32.11s-22.62-8.32-22.62-32.11v-32h45.25Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,181.87v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235,181.87v32.06c0,23.79-22.62,32.11-22.62,32.11s-22.62-8.32-22.62-32.11v-32H235Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233.55,181.87v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,155.62v32.05c0,23.8-22.62,32.12-22.62,32.12S0,211.46,0,187.67V155.62Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.79,155.62v31.7c0,21.89-21.17,29.55-21.17,29.55S1.46,209.19,1.46,187.32v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,155.62v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V155.62Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.12,155.62v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,155.62v32.05c0,23.8-22.62,32.12-22.62,32.12S83.2,211.46,83.2,187.67V155.62Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127,155.62v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,155.62v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V155.62Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.32,155.62v31.7c0,21.89-21.17,29.55-21.17,29.55S127,209.19,127,187.32v-31.7Z",
    transform: "translate(0 0)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,155.62v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V155.62Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M211.65,155.62v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,129.37v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.23,129.37v31.7c0,21.89-21.17,29.55-21.17,29.55S21.9,182.94,21.9,161.07v-31.7Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,129.37v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56,129.37v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,129.37v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.89,129.37v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,129.37v32c0,23.79-22.63,32.12-22.63,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,129.37v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235,129.37v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M233.55,129.37v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,103.11v32c0,23.79-22.62,32.12-22.62,32.12S0,159,0,135.16v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.79,103.11v31.7c0,21.89-21.17,29.55-21.17,29.55S1.46,156.68,1.46,134.81v-31.7Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,103.11v32C87.58,159,65,167.28,65,167.28S42.33,159,42.33,135.16v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.12,103.11v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,103.11v32c0,23.79-22.62,32.12-22.62,32.12S83.2,159,83.2,135.16v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127,103.11v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,103.11v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M169.32,103.11v31.7c0,21.89-21.17,29.55-21.17,29.55S127,156.68,127,134.81v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,103.11v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M211.65,103.11v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55v-31.7Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,76.86v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V76.86Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.23,76.86v31.71c0,21.88-21.17,29.54-21.17,29.54S21.9,130.44,21.9,108.57V76.88H64.23Z",
    transform: "translate(0 0)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,76.86v32.05C108,132.71,85.39,141,85.39,141s-22.62-8.33-22.62-32.12V76.86Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56,76.86v31.71c0,21.88-21.17,29.54-21.17,29.54s-21.17-7.68-21.17-29.54V76.88h42.33Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,76.86v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V76.86Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.89,76.86v31.71c0,21.88-21.17,29.54-21.17,29.54s-21.17-7.68-21.17-29.54V76.88h42.33Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,76.86v32.05c0,23.8-22.63,32.12-22.63,32.12s-22.62-8.33-22.62-32.12V76.86Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,76.86v31.71c0,21.88-21.17,29.54-21.17,29.54s-21.17-7.68-21.17-29.54V76.88h42.33Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235,76.86v32.05c0,23.8-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12V76.86Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M233.55,76.86v31.71c0,21.88-21.17,29.54-21.17,29.54s-21.17-7.68-21.17-29.54V76.88h42.33Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,50.61v32c0,23.79-22.62,32.12-22.62,32.12S0,106.46,0,82.66v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.79,50.61v31.7c0,21.89-21.17,29.55-21.17,29.55S1.46,104.18,1.46,82.31V50.61Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,50.61v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.12,50.61v31.7C86.12,104.2,65,111.87,65,111.87s-21.17-7.68-21.17-29.55V50.61Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,50.61v32c0,23.79-22.62,32.12-22.62,32.12S83.2,106.46,83.2,82.66v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M127,50.61v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55V50.61Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.78,50.61v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M169.32,50.61v31.7c0,21.89-21.17,29.55-21.17,29.55S127,104.18,127,82.31V50.61Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,50.61v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.65,50.61v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55V50.61Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,24.36v32c0,23.79-22.62,32.12-22.62,32.12S20.44,80.21,20.44,56.41v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64.23,24.36v31.7c0,21.89-21.17,29.55-21.17,29.55S21.9,77.93,21.9,56.06V24.36Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,24.36v32c0,23.79-22.62,32.12-22.62,32.12S62.77,80.21,62.77,56.41v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56,24.36v31.7c0,21.89-21.17,29.55-21.17,29.55S64.23,77.93,64.23,56.06V24.36Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,24.36v32c0,23.79-22.62,32.12-22.62,32.12S105.1,80.21,105.1,56.41v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.89,24.36v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55V24.36Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,24.36v32c0,23.79-22.63,32.12-22.63,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,24.36v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55V24.36Z",
    transform: "translate(0 0)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235,24.36v32c0,23.79-22.62,32.12-22.62,32.12s-22.62-8.33-22.62-32.12v-32Z",
    transform: "translate(0 0)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M233.55,24.36v31.7c0,21.89-21.17,29.55-21.17,29.55s-21.17-7.68-21.17-29.55V24.36Z",
    transform: "translate(0 0)",
    fill: "#a18357"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.28,7,80.12,7C63.65,13.16,46.24,23,30.24,9.49c0,0,1.52,57.1,62.7,54.84a161.2,161.2,0,0,0,21-3A96.64,96.64,0,0,0,129.74,57c4.83-1.89,8.76-5.91,13.64-7.42a18.22,18.22,0,0,1,5.22-.6c18.6-.18,29.78-6.12,50-3.4.25,0-7-8.11-7.2-8.57A74.42,74.42,0,0,0,177,17.61C154.16-4.24,107.8-3.21,80.28,7",
    transform: "translate(0 0)",
    fill: "#262322"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.89,50.57S17,77.95,14.78,85.66c0,0,2.78-25,23.72-48.16Z",
    transform: "translate(0 0)",
    fill: "#262322"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.47,
    cy: 145.83,
    rx: 41.15,
    ry: 37.71,
    transform: "translate(-22.91 10.75) rotate(-9.32)",
    fill: "#4a4a4c"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M56.94,170.67c13.51-2.22,22.85-14.1,20.82-26.48s-14.68-20.65-28.2-18.44-22.86,14.1-20.82,26.48S43.43,172.89,56.94,170.67Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.92,131.52S47.34,124,94,155.06c0,0,13.12-41-32.08-48.06C61.91,107,33.24,100.67,16.92,131.52Z",
    transform: "translate(0 0)",
    fill: "#957950"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M93,158s-53.89,26-77.88-21.85c0,0-14.44,39.49,32,48.7C47.07,184.85,81.67,188.68,93,158Z",
    transform: "translate(0 0)",
    fill: "#957950"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.17,
    cy: 145.83,
    rx: 37.71,
    ry: 41.15,
    transform: "translate(7.07 299.99) rotate(-80.68)",
    fill: "#4a4a4c"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M177.69,170.67c-13.51-2.22-22.85-14.1-20.82-26.48s14.68-20.65,28.2-18.44,22.86,14.1,20.82,26.48S191.2,172.89,177.69,170.67Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M217.72,131.52s-30.42-7.5-77.07,23.54c0,0-13.12-41,32.08-48.06C172.73,107,201.4,100.67,217.72,131.52Z",
    transform: "translate(0 0)",
    fill: "#957950"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.67,158s53.89,26,77.88-21.85c0,0,14.44,39.49-32,48.7C187.57,184.85,153,188.68,141.67,158Z",
    transform: "translate(0 0)",
    fill: "#957950"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBankharHead, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bankhar-head.0cc4746f.svg";
export { ForwardRef as ReactComponent };